"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndexedDb = void 0;
/* eslint-disable @typescript-eslint/no-unused-expressions */
const core_1 = require("../../core");
const options_1 = require("../options");
const indexedDB_fullySupportTest_1 = __importDefault(require("./indexedDB.fullySupportTest"));
const INDEXED_DB_PREFIX = '[IndexedDb]';
const STORAGE = 'storage';
var TransactionId;
(function (TransactionId) {
    TransactionId["CreateOpen"] = "create/open";
    TransactionId["GetItem"] = "getItem";
    TransactionId["SetItem"] = "setItem";
    TransactionId["RemoveItem"] = "removeItem";
    TransactionId["Clear"] = "clear";
    TransactionId["Delete"] = "delete";
})(TransactionId || (TransactionId = {}));
class IndexedDb extends core_1.CoreBaseModule {
    constructor(options) {
        super(options_1.storeOptionsDefault, Object.assign({}, options));
        this.loaded = false;
    }
    static isSupported() {
        return (0, indexedDB_fullySupportTest_1.default)();
    }
    init() {
        const { prefix } = this.getOptions();
        if (this.loaded) {
            return Promise.resolve();
        }
        return this.performStoreRequest({
            getRequest: () => {
                return window.indexedDB.open(prefix, 1);
            },
            id: TransactionId.CreateOpen,
        }, {
            onsuccess: (result) => {
                this.database = result;
                this.loaded = true;
            },
            onupgradeneeded: (result) => {
                this.database = result;
                this.database.createObjectStore(STORAGE);
                this.loaded = true;
            },
        });
    }
    getObjectStore() {
        return this.database.transaction(STORAGE, 'readwrite').objectStore(STORAGE);
    }
    getItem(key) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.init();
            return this.performStoreRequest({
                getRequest: () => {
                    const objectStore = this.getObjectStore();
                    return objectStore.get(key);
                },
                id: TransactionId.GetItem,
            });
        });
    }
    setItem(key, value) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.init();
            return this.performStoreRequest({
                getRequest: () => {
                    const objectStore = this.getObjectStore();
                    return objectStore.put(value, key);
                },
                id: TransactionId.SetItem,
            });
        });
    }
    removeItem(key) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.init();
            return this.performStoreRequest({
                getRequest: () => {
                    const objectStore = this.getObjectStore();
                    return objectStore.delete(key);
                },
                id: TransactionId.RemoveItem,
            });
        });
    }
    clear() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.init();
            return this.performStoreRequest({
                getRequest: () => {
                    const objectStore = this.getObjectStore();
                    return objectStore.clear();
                },
                id: TransactionId.Clear,
            });
        });
    }
    delete() {
        return __awaiter(this, void 0, void 0, function* () {
            const { prefix } = this.getOptions();
            yield this.init();
            return this.performStoreRequest({
                getRequest: () => {
                    return window.indexedDB.deleteDatabase(prefix);
                },
                id: TransactionId.Delete,
            }, {
                onsuccess: () => {
                    this.loaded = false;
                },
            });
        });
    }
    performStoreRequest(transaction, callbacks) {
        const { prefix } = this.getOptions();
        const { getRequest, id: transactionPrefix } = transaction;
        return new Promise((resolve, reject) => {
            const request = getRequest();
            request.onerror = error => {
                core_1.Log.info(INDEXED_DB_PREFIX + ' - ' + prefix + ' - ' + transactionPrefix + '- error');
                if (callbacks) {
                    if (callbacks.onerror) {
                        callbacks.onerror(error);
                    }
                }
                reject(error);
            };
            request.onsuccess = (event) => {
                core_1.Log.info(INDEXED_DB_PREFIX + ' - ' + prefix + ' - ' + transactionPrefix + '- success');
                if (callbacks) {
                    if (callbacks.onsuccess) {
                        callbacks.onsuccess(event.target.result);
                    }
                }
                resolve(event.target.result);
            };
            callbacks &&
                callbacks.onupgradeneeded &&
                (() => {
                    if ('onupgradeneeded' in request) {
                        request.onupgradeneeded = (event) => {
                            callbacks && callbacks.onupgradeneeded && callbacks.onupgradeneeded(event.target.result);
                        };
                    }
                })();
        });
    }
}
exports.IndexedDb = IndexedDb;
//# sourceMappingURL=indexedDB.js.map